import { useState } from 'react';

const useModal = (status?: boolean) => {
    const [visible, setVisible] = useState(status);
    function toggle() {
        setVisible(visible => !visible);
    }
    return { toggle, visible }
};

export default useModal;